<template>
  <div>
    <div id="spinner" :style="{ left: centerPoint.x, top: centerPoint.y }">
      <div>
        <div
          v-for="(ball, b) in balls"
          :key="b"
          :id="ball.id"
          class="ball"
          :style="{
            backgroundColor: color,
            opacity: ball.opacity,
          }"
        ></div>

        <small v-if="text" :style="{ color: color }">
          {{ text }}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['text'],
  data() {
    return {
      centerPoint: { x: 0, y: 0 },
      balls: [
        { id: 'a', opacity: '0.65' },
        { id: 'b', opacity: '0.7' },
        { id: 'c', opacity: '0.75' },
        { id: 'd', opacity: '0.8' },
        { id: 'e', opacity: '0.85' },
        { id: 'f', opacity: '0.9' },
        { id: 'g', opacity: '0.95' },
        { id: 'h', opacity: '1' },
      ],
    }
  },
  created() {
    this.centerPoint.x = window.innerWidth / 2 + 'px'
    this.centerPoint.y = window.innerHeight / 2 + 'px'
  },
  mounted() {},
  computed: {
    ...mapGetters(['user']),
    color() {
      return this.user?.app?.color || '#f0f'
    },
  },
  methods: {},
}
</script>

<style scoped>
#spinner {
  position: relative;
  background: rgb(237 237 237 / 80%);
  border-radius: 8px;
  transform: translate(-50%, -50%);
  z-index: 1001;
}

#spinner > div {
  height: 90px;
  width: 90px;
  padding: 10px;
  text-align: center;
}

#spinner > div > small {
  position: absolute;
  font-size: 60%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.ball {
  position: absolute;
  width: 10px;
  height: 10px;
  left: calc(50% - 5px);
  border-radius: 5px;
  animation-duration: 5s;
  -webkit-transform-origin-x: 5px;
  -webkit-transform-origin-y: 35px;
}

#a,
#b,
#c,
#d,
#e,
#f,
#g,
#h {
  animation-name: rotate;
  animation-iteration-count: infinite;
}

#a {
  animation-timing-function: cubic-bezier(0.5, 0.2, 0.9, 0.9);
}

#b {
  animation-timing-function: cubic-bezier(0.5, 0.27, 0.9, 0.9);
}

#c {
  animation-timing-function: cubic-bezier(0.5, 0.34, 0.9, 0.9);
}

#d {
  animation-timing-function: cubic-bezier(0.5, 0.41, 0.9, 0.9);
}

#e {
  animation-timing-function: cubic-bezier(0.5, 0.48, 0.9, 0.9);
}

#f {
  animation-timing-function: cubic-bezier(0.5, 0.55, 0.9, 0.9);
}

#g {
  animation-timing-function: cubic-bezier(0.5, 0.62, 0.9, 0.9);
}

#h {
  animation-timing-function: cubic-bezier(0.5, 0.69, 0.9, 0.9);
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  /* 50% {
    box-shadow: 0px 0px 10px #5086cc;
  } */
  100% {
    transform: rotate(1440deg) scale(1);
  }
}
</style>
